// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const tr: ChromeTranslations = {
  'nav.nextPage': 'sonraki sayfa →',
  'nav.previousPage': '← önceki sayfa',
  'nav.continueToLevel': 'bölüme devam →',
  'nav.backToMenu': 'menüye dön →',
  'howto.page': 'sayfa {n} / {total}',
  'options.title': 'Seçenekler',
  'ui.language': 'Dil',
};
